import { useCallback, useMemo } from 'react'

import type { ColumnDef } from '@tanstack/react-table'
import { useUnit } from 'effector-react'
import { useNavigate } from 'react-router'

import IconChevronRight from '@/assets/icons/icon-chevron-right.svg'
import { Button } from '@/components/ui/button'
import { $creatorId } from '@/models/creators.ts'
import { ListLabel } from '@/modules/tiktok-research/videos/ui/ListLabel.tsx'
import type { TikTokContentListType } from '@/modules/tiktok-research/videos/ui/types'
import { AppRoutes } from '@/utils/constants'

export const useListsTableColumns = (): ColumnDef<TikTokContentListType>[] => {
  const creatorId = useUnit($creatorId) || 0
  const navigate = useNavigate()

  const handleClickOpenDetails = useCallback(
    (id: number) => {
      navigate(
        AppRoutes.TiktokResearch.Lists.Details.Index.asUrl(
          creatorId,
          String(id),
        ),
      )
    },
    [creatorId, navigate],
  )

  return useMemo(
    () => [
      {
        accessorKey: 'name',
        header: 'Name',
        cell: ({ row }) => (
          <ListLabel
            list={row.original}
            className="space-x-2 text-sm leading-6 [&>svg]:h-5 [&>svg]:w-5"
          />
        ),
      },
      {
        accessorKey: 'action',
        header: () => <div className="ml-auto">Action</div>,
        cell: ({ row: { original: list } }) => (
          <Button
            variant="ghost"
            className="ml-auto flex p-0"
            onClick={() => handleClickOpenDetails(list.id)}
          >
            Open List
            <IconChevronRight className="ml-1" />
          </Button>
        ),
      },
    ],
    [handleClickOpenDetails],
  )
}
